import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

/**
 * Catch-all for unmatched URLs.
 *
 * Without this an unknown path rendered an empty <main>, so a mistyped link -
 * or a stale bundle that has not yet learnt a new route - looked identical to
 * the app being broken.
 */
const NotFound: React.FC = () => (
  <div className="min-h-[60vh] flex items-center justify-center px-4">
    <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-brand-100 bg-surface shadow-sm">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-brand-50/70 via-surface to-surface" />

      <div className="relative flex flex-col items-center px-6 py-14 text-center">
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl
                        bg-brand-50 text-brand-500 ring-1 ring-brand-100">
          <Compass className="w-7 h-7" />
        </div>

        <span className="mb-3 text-[10px] font-medium uppercase tracking-[0.2em] text-brand-500">
          Page not found
        </span>

        <h1 className="font-display font-normal tracking-tight mb-3 text-2xl text-ink-900">
          We couldn't find that page
        </h1>

        <p className="mb-7 max-w-sm text-sm font-light leading-relaxed text-ink-500">
          The link may be out of date, or the page may have moved.
        </p>

        <Link
          to="/"
          className="rounded-lg bg-brand-50 px-5 py-2.5 text-sm font-medium text-brand-600
                     transition-colors duration-200 hover:bg-brand-100"
        >
          Back to venues
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
